<div class="sx-environment__landing-wrapper">
    @if(information){
      <div [innerHTML]="information.content | safeHtml" appRouterLink></div>
    }
    @else {
      <app-no-content [displayText]="('environment.display.empty' | translate)"></app-no-content>
    }
</div>
